import { Box, Typography } from "@mui/material";
import { SpendTable } from "../SpendTable";
import { SpendDonutChart } from "../SpendDonutChart";
import { WaterfallChart } from "../WaterfallChart";
import { TitleBar } from "../utils/SpendFunctions";
import {
  COST_DRIVERS_COLUMNS,
  INFLATION_OVERVIEW_COLUMNS,
  COMMODITY_INFLATION_COLUMNS,
} from "../constants";
import { SPEND_COST_DRIVERS_DESC } from "./costDriversDescription";

export const SpendCostDriversSection = ({
  costDrivers,
  inflationOverview,
  commodityInflation,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
    {/* CostDriver description */}
    <Typography variant="body2" sx={{ mb: 5, mt: -3 }}>
      {SPEND_COST_DRIVERS_DESC}
    </Typography>

    {/* Category Breakdown by Index */}
    <Box>
      <TitleBar title={"Category Breakdown by Index"} />
      {costDrivers?.length ? (
        <SpendDonutChart columns={COST_DRIVERS_COLUMNS} rows={costDrivers} />
      ) : (
        <Typography sx={{ color: "text.secondary" }}>
          No cost drivers data available.
        </Typography>
      )}
    </Box>

    {/* Inflation Overview */}
    <Box>
      <TitleBar title={"Inflation Overview"} />
      {inflationOverview?.length ? (
        <SpendTable
          columns={INFLATION_OVERVIEW_COLUMNS}
          rows={inflationOverview}
        />
      ) : (
        <Typography sx={{ color: "text.secondary" }}>
          No inflation overview data available.
        </Typography>
      )}
    </Box>

    {/* Inflation Breakdown by Commodity */}
    <Box>
      <TitleBar title={"Inflation Breakdown by Commodity"} />
      {commodityInflation?.length ? (
        <WaterfallChart
          columns={COMMODITY_INFLATION_COLUMNS}
          rows={commodityInflation}
        />
      ) : (
        <Typography sx={{ color: "text.secondary" }}>
          No commodity inflation data available.
        </Typography>
      )}
    </Box>
  </Box>
);
